import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import { sortComparator } from '../../../../../SharedModules/CommonUtilities/commonUtilities';

const comparator = (a, b) => {
  const splittedQtrA = a?.split('Q') || [0, 0];
  const splittedQtrB = b?.split('Q') || [0, 0];
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};

export const defaultCgpDetailTableHead = [
  {
    headerName: 'Grouping Column Value',
    field: 'groupingColumnValue',
    required: true,
    editable: false,
    suppressMenu: false,
    sortable: true,
    cellRenderer: 'IDTextbox',
    cellEditorParams: {
      maxLength: 10,
      custWidth: '135px',
    },
    minWidth: 250,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    comparator: sortComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: 'right',
    excelAlignment: 'right',
  },
  {
    headerName: 'Group Number',
    field: 'groupNum',
    required: true,
    editable: false,
    suppressMenu: false,
    sortable: true,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'GroupNumTextbox',
    cellStyle: { 'border-right-color': Styles.BorderColor },

    minWidth: 192,
    cellEditorParams: {
      maxLength: 2,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: 'right',
    excelAlignment: 'right',
  },
  {
    headerName: 'Reporting Header',
    field: 'groupHeader',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'ReportingHeaderTextbox',
    minWidth: 195,
    cellEditorParams: {
      maxLength: 20,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    cellStyle: { 'border-right-color': Styles.BorderColor },

    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Start Quarter',
    field: 'startQtr',
    required: true,
    editable: false,
    suppressMenu: false,
    sortable: true,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'StartQtrTextbox',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    minWidth: 180,
    cellEditorParams: {
      maxLength: 6,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator
  },
  {
    headerName: 'End Quarter',
    field: 'endQtr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'EndQtrTextbox',
    minWidth: 160,
    cellEditorParams: {
      maxLength: 6,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    cellStyle: { 'border-right-color': Styles.BorderColor },

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'endsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator
  },
];

export const deleteColumn = [
  {
    headerName: 'Actions',
    cellRenderer: 'deleteBoxRenderer',
    filter: false,
    sortable: false,
    editable: false,
    suppressMenu: false,
    minWidth: 84,
    resizable: false,
    maxWidth: 100,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },

    pdfExportOptions: {
      skipColumn: true,
    },
  },
];

export const planIdCgpDetailTableHead = [
  {
    headerName: 'Plan ID',
    field: 'groupingColumnValue',
    required: true,
    editable: false,
    suppressMenu: false,
    sortable: true,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'IDTextbox',
    minWidth: 140,
    cellEditorParams: {
      maxLength: 10,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  ...defaultCgpDetailTableHead.slice(1, defaultCgpDetailTableHead.length),
];

export const providerCgpDetailTableHead = [
  {
    headerName: 'Alternate Provider ID',
    field: 'groupingColumnValue',
    required: true,
    editable: false,
    suppressMenu: false,
    sortable: true,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'IDTextbox',
    minWidth: 232,
    comparator: sortComparator,
    cellEditorParams: {
      maxLength: 10,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    cellStyle: { 'border-right-color': Styles.BorderColor },

    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  ...defaultCgpDetailTableHead.slice(1, defaultCgpDetailTableHead.length),
];

export const MCOCgpDetailTableHead = [
  {
    headerName: 'MCO Indicator',
    field: 'groupingColumnValue',
    required: true,
    editable: false,
    suppressMenu: false,
    sortable: true,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'IDTextbox',
    minWidth: 186,
    cellEditorParams: {
      maxLength: 10,
      custWidth: '135px',
    },
    cellStyle: { 'border-right-color': Styles.BorderColor },

    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  ...defaultCgpDetailTableHead.slice(1, defaultCgpDetailTableHead.length),
];
